import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import { ORIENTATION } from '../../../services/cards/constants';
import PrintProductConfigurator from '../../../services/prints/components/PrintProductConfigurator';
import getAccountCardQuery from '../../../services/cards/graphql/queries/getAccountCard';
import Spinner from '../../../components/global/Spinner';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      accountCardId: PropTypes.string,
    }),
  }),
};

const AccountCardPrintProductConfigurationView = ({ match }) => {
  const { data: { accountCard } = {} } = useQuery(getAccountCardQuery, {
    variables: {
      id: match.params.accountCardId,
    },
    skip: !match.params.accountCardId,
    fetchPolicy: 'cache-and-network',
  });

  if (!accountCard) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <PrintProductConfigurator
      forceOpen
      storeFetchedAccountCard
      printProductId={accountCard.print_product_configuration.print_product.id}
      printProductSizeId={
        accountCard.print_product_configuration.print_product_size.id
      }
      printProductSizeServiceIds={(
        accountCard.print_product_configuration.print_product_size_services
          .records ?? []
      ).map(service => service.id)}
      availablePrintProductSizeIds={[
        accountCard.print_product_configuration.print_product_size.id,
      ]}
      orientation={
        accountCard.account_card_sides?.[0].card_side?.card_template
          ?.orientation ?? ORIENTATION.LANDSCAPE
      }
      onClose={() => {}}
      onComplete={() => {}}
      buttonText="Done"
      defaultAccountCard={accountCard}
      disablePhotoWatermarkOverlay
      allowPhotoChange
    />
  );
};

AccountCardPrintProductConfigurationView.propTypes = propTypes;

export default withRouter(AccountCardPrintProductConfigurationView);
